import { render } from "./FunctionsCatalogPreviewTable.vue?vue&type=template&id=e8ab26e6&ts=true"
import script from "./FunctionsCatalogPreviewTable.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogPreviewTable.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogPreviewTable.vue?vue&type=style&index=0&id=e8ab26e6&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__